let tableColumnData = [
  {
    label: '',
    background: '#def0d6',
    type: 'project',
    children: [
      { label: '序号', key: 'serialNumber', showInLiteVersion: true, width: 50 },
      { label: '直接交易主体', key: 'fundNameProject', showInLiteVersion: true },
      { label: '项目简称', key: 'portFolio', showInLiteVersion: true }
    ]
  },
  {
    label: 'Portfolio基础信息',
    background: '#def0d6',
    type: 'project',
    children: [
      // { label: '项目简称', key: 'portFolio', showInLiteVersion: true },
      { label: '项目状态-by基金', key: 'companyAndInvestFundStatus', showInLiteVersion: true },
      { label: '工商名称', key: 'businessName' },
      { label: '公司注册地', key: 'registerRegion' },
      { label: '所属赛道', key: 'bussiness', showInLiteVersion: true },
      { label: '是否522', key: 'isFivett' },
      { label: '是否中小企业', key: 'isSmes' },
      { label: '一句话简介', key: 'description' },
      { label: '项目DL(天池)/投后管理对接人', key: 'projectPeopleName' },
      { label: '董事会席位源码代理人', key: 'ourBoardPerson' },
      { label: '项目来源', key: 'companySource' },
      { label: 'Initial/Follow-on', key: 'nodeType' },
      { label: '项目架构', key: 'companyStructure' }
    ]
  },
  {
    label: 'FMV信息-by项目',
    background: '#dbecf8',
    type: 'project',
    children: [
      { label: '未实现总成本', key: 'totalCost', showInLiteVersion: true },
      { label: '未实现总公允价值', key: 'totalFMV', showInLiteVersion: true },
      { label: '未实现总收益', key: 'totalIncome', showInLiteVersion: true },
      { label: '未实现部分总股比', key: 'fullyDilutedOwnership', showInLiteVersion: true },
      { label: '未实现部分总MOIC', key: 'totalMOIC', showInLiteVersion: true },
      { label: '未退出部分IRR', key: 'irr', showInLiteVersion: true }
    ]
  },
  {
    label: 'FMV信息-by轮次',
    background: '#fff1c7',
    type: 'round',
    children: [
      { label: '持股轮次', key: 'classOfShare', showInLiteVersion: true },
      { label: 'Initial/Follow-on（交易）', key: 'nodeTypeRound', showInLiteVersion: true }, // new
      { label: '投资日期', key: 'initialInvestmentDate', showInLiteVersion: true },
      { label: '未实现成本', key: 'investmentCost', showInLiteVersion: true },
      { label: '最新持有股数', key: 'shareNum', showInLiteVersion: true },
      { label: '未实现公允价值', key: 'fairValue', showInLiteVersion: true },
      { label: '未实现收益', key: 'cumulativeUnrealized', showInLiteVersion: true },
      { label: '未实现部分股比', key: 'fullyDilutedOwnership', showInLiteVersion: true },
      { label: '未实现MOIC', key: 'MOIC', showInLiteVersion: true },
      { label: '原始每股单价', key: 'originalSharePrice', showInLiteVersion: true }, // new
      { label: '回购截止时间', key: 'buybackDeadline', showInLiteVersion: true } // new
    ]
  },
  {
    label: '北冥最新估值标准',
    background: '#ededed',
    type: 'project',
    children: [
      { label: '最新估值变动时间', key: 'latestValuationDate' },
      { label: '估值调整逻辑', key: 'latestValuationMethod', showInLiteVersion: true },
      { label: '是否重点关注估值项目', key: 'latestFocusOnValuationCompany', showInLiteVersion: true },
      { label: '本季度有无影响估值的事项发生', key: 'latestValuationMatter', showInLiteVersion: true },
      { label: '估值调整轮次', key: 'latestValuationRoundsId' },
      { label: '估值币种', key: 'latestValuationCurrency' },
      { label: '估值币种记账日汇率', key: 'latestBookRate' },
      { label: '调整前估值', key: 'latestPreValuation' },
      { label: '调整后估值', key: 'latestPostValuation' },
      { label: '企业总股数', key: 'latestTotalShareNum' },
      { label: '估值每股单价', key: 'latestValuationPerShare' }
    ]
  },
  {
    label: '公司最新一轮信息（交易口径）',
    background: '#D3B4EE',
    type: 'round',
    children: [
      { label: '最新一轮融资轮次', key: 'latestRoundFinancingRoundId', showInLiteVersion: true },
      { label: '最新一轮估值币种', key: 'latestRoundValuationCurrency', showInLiteVersion: true },
      { label: '最新一轮财务交割时间', key: 'latestRoundFinancialDeliveryDate', showInLiteVersion: true },
      { label: '该轮投前估值', key: 'latestRoundPreValuation', showInLiteVersion: true },
      { label: '该轮投后估值', key: 'latestRoundPostValuation', showInLiteVersion: true },
      { label: '投前持股比例', key: 'latestRoundPreShareRatio', showInLiteVersion: true },
      { label: '投后持股比例', key: 'latestRoundPostShareRatio', showInLiteVersion: true },
      { label: '公司最新轮投后总股数', key: 'latestRoundPostTotalShareNum', showInLiteVersion: true },
      { label: '公司最新轮每股单价', key: 'latestRoundPostShareUnitPrice', showInLiteVersion: true },
      { label: '公司当前总股数', key: 'latestRoundCurrentTotalShareNum', showInLiteVersion: true }
    ]
  },
  {
    label: '财务调整估值信息',
    background: '#ffe4d3',
    type: 'round',
    children: [
      { label: '是否有财务估值调整', key: 'isFinancialAdjustment', showInLiteVersion: true },
      { label: '财务估值调整时点', key: 'financialAdjustmentDate', showInLiteVersion: true },
      { label: '财务调整估值币种', key: 'financialAdjustmentCurrency', showInLiteVersion: true },
      { label: '财务调整每股单价', key: 'financialAdjustmentShareUnitPrice', showInLiteVersion: true },
      { label: '财务调整后的公司估值', key: 'financialAdjustmentPostValuation', showInLiteVersion: true },
      { label: 'Rounding调整', key: 'roundingAdjust', showInLiteVersion: true }
    ]
  },
  {
    label: '汇率影响的评估',
    background: '#ffe4d3',
    type: 'round',
    children: [{ label: '记账日汇率', key: 'exchangeRate', showInLiteVersion: true }]
  },
  {
    label: '交易记录-原始投资轮次信息',
    background: '#ffe48d',
    type: 'round',
    children: [
      { label: '本轮交易类型', key: 'dealType' },
      { label: '本轮交易轮次', key: 'investClassOfShare' },
      { label: '企业所处轮次', key: 'thisClassOfShareId' },
      { label: '直接交易主体', key: 'fundName' },
      { label: '穿透最终投资主体及投资成本', key: 'penetrateFund' },
      { label: '投资币种', key: 'currency' },
      { label: '财务交割日期', key: 'deliveryDate' },
      { label: '实际投资金额', key: 'amount' },
      { label: '本轮持有股数', key: 'investShareNum' },
      { label: '投时持股占比', key: 'preShareScale' },
      { label: '原始交易每股单价', key: 'shareUnitPrice' },
      { label: '本轮融资总金额', key: 'financingAllAmount' },
      { label: '共同投资人及其投资金额', key: 'otherInvestors' },
      { label: '本轮DL', key: 'dlName' },
      { label: '本轮DDL', key: 'ddlName' },
      { label: '本轮所属BU', key: 'bu' },
      { label: '是否领投', key: 'enterExitType' }
    ]
  },
  {
    label: '交易记录-原始投资时点估值信息',
    background: '#ffc9a9',
    type: 'round',
    children: [
      { label: '估值币种', key: 'originalValuationCurrency' },
      { label: '估值币种记账日汇率', key: 'originalBookRate' },
      { label: '投前估值', key: 'originalPreValuation' },
      { label: '投后估值', key: 'originalPostValuation' },
      { label: '企业总股数', key: 'originalTotalShareNum' },
      { label: '估值每股单价', key: 'originalShareUnitPrice' }
    ]
  },
  {
    label: 'FMV调整',
    background: '#ffcbc3',
    type: 'round',
    children: [
      { label: '计算FMV时本轮应用的估值每股单价 ', key: 'thisShareUnitPrice' },
      { label: 'FMV手动调整', key: 'adjust' }
    ]
  },
  // {
  //   label: '最新一次公司事件（IPO/重组/其他）对本交易记录的影响',
  //   background: '#b7d8f1',
  //   type: 'round',
  //   children: [
  //     { label: '事件类型', key: 'eventType' },
  //     { label: '事件发生时间/IPO时间/重组时间', key: 'eventHappenDate' },
  //     { label: '事件生效时间', key: 'eventEffectDate' },
  //     { label: '事件原因及过程简要描述', key: 'eventTypeRemark' },
  //     { label: '事件发生后本轮轮次', key: 'eventClassOfShareId' },
  //     { label: '事件发生后本轮资产性质', key: 'eventNature' },
  //     { label: '事件发生后本轮直接交易主体', key: 'eventFundName' },
  //     { label: '事件发生后本轮计量币种', key: 'eventCurrency' },
  //     { label: '事件发生后本轮持有部分成本', key: 'eventAmount' },
  //     { label: '事件发生后本轮持有股数', key: 'eventShareNum' },
  //     { label: '事件发生后企业总股数', key: 'eventTotalShareNum' },
  //     { label: '事件发生后本轮持有股比', key: 'eventSharePer' },
  //     { label: '事件发生后本轮每股股价', key: 'eventAmountUnitShare' }
  //   ]
  // },
  {
    label: '其他',
    background: '#ededed',
    type: 'round',
    children: [
      { label: '投后新增轮次融资情况', key: 'newRoundOfFinancingAfterInvestment' },
      { label: '说明/备注', key: 'remark', showInLiteVersion: true }
    ]
  }
];

let count = 0;
let tableColumnDataWithCount = tableColumnData.map(item => {
  return {
    ...item,
    count: item.children.length,
    children: item.children.map((child, index) => {
      return {
        ...child,
        index: count++
      };
    })
  };
});

// 生成一个map,格式为{[num]: color},其中num为列数，color为背景色
let countSum = 0;
export const colorMap = tableColumnDataWithCount.map(cur => {
  countSum += cur.count;
  return {
    count: countSum,
    color: cur.background
  };
}, {});
console.log('colorMap', colorMap);

// 导出精简版展示的表头index数组
export const liteVersionMap = tableColumnDataWithCount.reduce((prev, cur) => {
  return prev.concat(
    cur.children
      .filter(_ => _.showInLiteVersion)
      .map(item => {
        return item.index;
      })
  );
}, []);
console.log('liteVersionMap', liteVersionMap);

// 最终展示的数据在structData里
export const structData = [
  tableColumnDataWithCount.reduce((prev, cur) => {
    return prev.concat(
      cur.children.map((item, index) => {
        return {
          value: item.label,
          border: item.label === '项目简称' ? 1 : 0,
          // border: (index===cur.children.length-1) ? 1 : 0,
          // border: 0,
          background: cur.background,
          bold: true,
          index: item.index,
          eleProperty: [],
          textAlign: !cur.label ? 'left' : 'right'
        };
      })
    );
  }, [])
];

console.log(structData);

// 每列对应的字段英文名
export const columnMap = tableColumnDataWithCount.reduce((prev, cur) => {
  return prev.concat(
    cur.children.map(item => {
      return item.key;
    })
  );
}, []);

export const settings = {
  // https://handsontable.com/docs/javascript-data-grid/row-height/
  licenseKey: 'non-commercial-and-evaluation',
  data: [],
  height: 120 + 17 * 30,
  width: '100%',
  // autoRowSize: true,
  // colHeaders: true,
  // rowHeaders: true,// 自动行序号
  rowHeights: 30,
  // colWidths: 100,

  // manualRowResize: true,
  colWidths: tableColumnDataWithCount.reduce((prev, cur) => {
    return prev.concat(
      cur.children.map(item => {
        return item.width ? item.width : '100';
      })
    );
  }, []),
  // colWidths: [50].concat(Array(structData[0].length).fill(100)),
  // colWidths: true,// 列宽,可以为数组,可以为true(自动)
  // hiddenColumns: {
  //   columns: [],
  //   indicators: true
  // },
  // renderAllRows: true,// 关闭动态渲染表格
  // viewportColumnRenderingOffset: 120,
  hiddenColumns: {
    columns: tableColumnDataWithCount.reduce((prev, cur) => {
      return prev.concat(
        cur.children
          .filter(_ => !_.showInLiteVersion)
          .map(item => {
            return item.index;
          })
      );
    }, [])
    // indicators: true
  },
  // 实际的表头展示
  nestedHeaders: [
    // 表头第一行
    tableColumnDataWithCount.map((e, index) => {
      return {
        label: e.label,
        colspan: e.count
      };
    }),
    // 表头第二行
    tableColumnDataWithCount.reduce((prev, cur) => {
      return prev.concat(
        cur.children.map((e, index) => {
          return {
            label: e.label,
            colspan: 1
          };
        })
      );
    }, [])
  ],

  columns: Array(structData[0].length).fill({}),

  afterRenderer: (td, row, col, prop, value, cellProperties) => {
    renderStyle(td, row, col, prop, value, cellProperties);
    return td;
  }
};

const sumMapEdit = {
  portFolio: 'serialNumber',
  totalCost: 'totalCost',
  totalFMV: 'totalFMV',
  totalIncome: 'totalIncome',
  totalMOIC: 'totalMOIC', // 退出部分总moic
  investmentCost: 'investmentCost',
  shareNum: 'shareNum',
  fairValue: 'fairValue',
  cumulativeUnrealized: 'cumulativeUnrealized',
  MOIC: 'MOIC'
};

// 遍历sumMap,把key转换成对应字段的index
export const sumMap = Object.fromEntries(
  Object.entries(sumMapEdit).map(([key, value]) => {
    return [
      key,
      tableColumnDataWithCount
        .reduce((prev, cur) => {
          return prev.concat(
            cur.children.map((item, index) => {
              return item.key;
            })
          );
        }, [])
        .indexOf(value)
    ];
  })
);

// 展示在project行的数据
export const projectMap = Object.fromEntries(
  tableColumnDataWithCount
    .filter(_ => _.type === 'project')
    .reduce((acc, cur) => {
      return acc.concat(cur.children.map((e, index) => [e.key, e.index]));
    }, [])
);

// 展示在round行的数据
export const fundMap = Object.fromEntries(
  tableColumnDataWithCount
    .filter(_ => _.type === 'round')
    .reduce((acc, cur) => {
      return acc.concat(cur.children.map((e, index) => [e.key, e.index]));
    }, [])
);

export const precisionMap = {
  zerobit: [
    'latestRoundCurrentTotalShareNum',
    'shareNum',

    'eventAmount',
    'proceeds',
    'totalProceeds',
    'allocatedAmount',
    // 'cumulativeUnrealized',
    'investAmount',
    'investFinancingAllAmount',
    'investOriginalPreValuation',
    'investOriginalPostValuation',
    'investShareNum'
  ],
  twobit: [
    'financingAllAmount',
    'totalCost',
    'totalFMV',
    'totalIncome',
    'investmentCost',
    'fairValue',
    'cumulativeUnrealized',
    'originalSharePrice',
    'latestRoundPreValuation',
    'latestRoundPostValuation',
    'latestRoundPostShareUnitPrice',
    'financialAdjustmentPostValuation',
    'latestPreValuation',
    'latestPostValuation',
    'amount',
    'originalPreValuation',
    'originalPostValuation',
    'roundingAdjust',
    'latestValuationPerShare',
    'shareUnitPrice',
    'pricePerShare',
    'originalShareUnitPrice',
    'thisShareUnitPrice',
    'adjust',
    'eventAmountUnitShare',
    'amountPerShareNum',
    'investShareUnitPrice',
    'investPricePerShare',
    'investOriginalShareUnitPrice',
    'investThisShareUnitPrice',
    'investAdjust',
    // 百分比
    'fullyDilutedOwnership',
    'preShareScale',
    'eventSharePer',
    'investPreShareScale',
    'totalFullyDilutedOwnership',
    'irr',
    'financialAdjustmentShareUnitPrice',
    'latestRoundPreShareRatio',
    'latestRoundPostShareRatio'
  ],
  fourbit: ['totalMOIC', 'MOIC', 'latestBookRate', 'originalBookRate', 'eventSharePer', 'reportRate', 'exitMOIC', 'investOriginalBookRate', 'exchangeRate']
};
function renderStyle(td, row, col, prop, value, cellProperties) {
  const obj = Object.assign({}, structData[row + 1][col]);
  Object.assign(td.style, obj.style);
  // console.log('renderStyle', row, col, prop, value);
  // 如果col小于等于2,切换class
  // 如果value特别长,切换class
  let className = col <= 2 ? 'handsontable-text-tooltip htt-left' : 'handsontable-text-tooltip htt-right';
  className += (typeof value === 'string' && value.length) > 15 ? ' htt-long' : '';

  td.innerHTML = `<span style="white-space: nowrap" class="handsontable-text">
    <div class="${className}">
    ${obj.innerHTML}
    </div>
    ${obj.innerHTML}
  </span>`;
  // td.innerHTML = obj.innerHTML;
  cellProperties.readOnly = obj.readOnly;
}
